"use client";

import { AuthContext } from "@/context/auth-context";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useContext } from "react";

export default function SignInItem() {
  const { isLoggedIn } = useContext(AuthContext);

  const pathname = usePathname();
  return !isLoggedIn ? (
    <Link
href={`/auth/welcome?redirect=${pathname ? encodeURIComponent(pathname) : '/'}`}
      className="font-medium text-xl md:text-base"
      prefetch={true}
    >
      Sign-in
    </Link>
  ) : null;
}
